import { Fragment } from 'react';
import classNames from 'classnames';

import { ElementShownAnchor } from '@hh.ru/analytics-js';
import serviceShown from '@hh.ru/analytics-js-events/build/xhh/applicant/hhpro/hhpro_service_description_element_shown';
import { Title, VSpacing, Text, useBreakpoint, TitleProps } from '@hh.ru/magritte-ui';

import { HhProServiceItem, HhProServiceType, HH_PRO_SERVICE_TYPE_UPPER_CAMEL_CASE } from 'src/types/hhpro';

import styles from './styles.less';

const EXCLUDE_SERVICES = [HhProServiceType.ResumeTargetEmployer] as const;

const Service: React.FC<{ service: HhProServiceItem; tariffId: string }> = ({ service, tariffId }) => {
    const breakpoint = useBreakpoint();

    if (EXCLUDE_SERVICES.includes(service.serviceType)) {
        return null;
    }

    let titleSize: TitleProps['size'] = 'medium';
    if (breakpoint.isM) {
        titleSize = 'large';
    } else if (breakpoint.isGtM) {
        titleSize = 'extra-large';
    }

    const lowerServiceType = HH_PRO_SERVICE_TYPE_UPPER_CAMEL_CASE[service.serviceType];

    return (
        <Fragment>
            <ElementShownAnchor
                className={styles.serviceBlock}
                fn={serviceShown}
                service={service.serviceType}
                tariffId={tariffId}
            >
                <div className={styles.content}>
                    <VSpacing default={0} gteM={40} />
                    <div className={classNames(styles.serviceIcon, styles[`serviceIcon${lowerServiceType}`])} />
                    <VSpacing default={0} gteM={24} />
                    <Title Element="h5" size={titleSize} style="contrast">
                        {service.title}
                    </Title>
                    <VSpacing default={8} />
                    <Text
                        style="contrast"
                        typography={breakpoint.isGtS ? 'paragraph-1-regular' : 'paragraph-3-regular'}
                    >
                        {service.description}
                    </Text>
                </div>
                <div className={classNames(styles.background, styles[`background${lowerServiceType}`])}>
                    <div className={classNames(styles.backgroundExtra, styles[`backgroundExtra${lowerServiceType}`])} />
                </div>
            </ElementShownAnchor>
            <VSpacing default={40} gteM={80} />
        </Fragment>
    );
};

export default Service;
